// This file is automatically generated. Do not edit it directly.
import { createClient } from '@supabase/supabase-js';
import type { Database } from './types';

const SUPABASE_URL = "https://zfywjmmtnpdokyxemqsf.supabase.co";
const SUPABASE_PUBLISHABLE_KEY = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InpmeXdqbW10bnBkb2t5eGVtcXNmIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI2MzE1MjEsImV4cCI6MjA1ODIwNzUyMX0.gNN7Vy2ERxDnMkox_Ug0LfBFl7tF6MRrwUCYpFxOy6s";

// Import the supabase client like this:
// import { supabase } from "@/integrations/supabase/client";

export const supabase = createClient<Database>(SUPABASE_URL, SUPABASE_PUBLISHABLE_KEY);